// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournaments-list-page_TournamentPage__DeSCU{
    width: 100%;
    min-height: 0px;
    flex: 1 1;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: start;
    padding-bottom: 20px;

    >div:nth-child(1) {
        width: 80%;
        /* min-width: 60vmax; */
    }

    >div:nth-child(2) {
        border-bottom: 1px solid black;
        margin: 9px 0px;
        width: 80%;
        background-color: white;
        padding: 0px 10px;
        border-radius: 6px;
    }
}

.tournaments-list-page_SearchQuery__SDP5n {
    width: 80%;
    height: max-content;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    >div:nth-child(1) {
        background-color: white;
        width: 50px;
        border-radius: 12px;
        
        >select {
            padding-left: 5px;
        }
    }

    >div:nth-child(2) {
        background-color: white;
        border-radius: 12px;
        padding: 0px 10px;
    }
}

.tournaments-list-page_TableContainer__d-Dlm > * {
    max-width: 1200px;
    width: 1200px;
}

.tournaments-list-page_ControlPanel__xwrcp{
    padding: 20px;;
    display: flex;
    justify-content: start;
}

.tournaments-list-page_ControlPanel__xwrcp > *{
    margin-left: 20px;
}

.tournaments-list-page_DataGrid__QNBPl{
    min-width: 60vmax;
    width: 80% !important;
}

.tournaments-list-page_SearchPanel__jY02l {
    width: 80%;
    min-width: 60vmax;
}

@media (max-width: 768px) {
    .tournaments-list-page_TournamentPage__DeSCU{
        >div:nth-child(2) {
            /* border-bottom: 1px solid black; */
            margin: 0px;
            width: 100%;
            /* background-color: white; */
            /* padding: 0px 10px; */
            border-radius: 0px;
        }
        >:nth-child(3) {
            overflow-x: unset;
            >table >tbody >tr {
                >:nth-child(1) {
                    display: none;
                }
            }
            >table >thead >tr {
                >:nth-child(1) {
                    display: none;
                }
            }
            >div {
                width: 100vw;
            }
        }
    }
    .tournaments-list-page_DataGrid__QNBPl{
        width: 100% !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/TournamentsListPageN/ui/tournaments-list-page.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;IACf,SAAO;IACP,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,oBAAoB;;IAEpB;QACI,UAAU;QACV,uBAAuB;IAC3B;;IAEA;QACI,8BAA8B;QAC9B,eAAe;QACf,UAAU;QACV,uBAAuB;QACvB,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI,UAAU;IACV,mBAAmB;;IAEnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;;IAEnB;QACI,uBAAuB;QACvB,WAAW;QACX,mBAAmB;;QAEnB;YACI,iBAAiB;QACrB;IACJ;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;QACnB,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI;QACI;YACI,oCAAoC;YACpC,WAAW;YACX,WAAW;YACX,6BAA6B;YAC7B,uBAAuB;YACvB,kBAAkB;QACtB;QACA;YACI,iBAAiB;YACjB;gBACI;oBACI,aAAa;gBACjB;YACJ;YACA;gBACI;oBACI,aAAa;gBACjB;YACJ;YACA;gBACI,YAAY;YAChB;QACJ;IACJ;IACA;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":[".TournamentPage{\n    width: 100%;\n    min-height: 0px;\n    flex: 1;\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n    padding-bottom: 20px;\n\n    >div:nth-child(1) {\n        width: 80%;\n        /* min-width: 60vmax; */\n    }\n\n    >div:nth-child(2) {\n        border-bottom: 1px solid black;\n        margin: 9px 0px;\n        width: 80%;\n        background-color: white;\n        padding: 0px 10px;\n        border-radius: 6px;\n    }\n}\n\n.SearchQuery {\n    width: 80%;\n    height: max-content;\n\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n\n    >div:nth-child(1) {\n        background-color: white;\n        width: 50px;\n        border-radius: 12px;\n        \n        >select {\n            padding-left: 5px;\n        }\n    }\n\n    >div:nth-child(2) {\n        background-color: white;\n        border-radius: 12px;\n        padding: 0px 10px;\n    }\n}\n\n.TableContainer > * {\n    max-width: 1200px;\n    width: 1200px;\n}\n\n.ControlPanel{\n    padding: 20px;;\n    display: flex;\n    justify-content: start;\n}\n\n.ControlPanel > *{\n    margin-left: 20px;\n}\n\n.DataGrid{\n    min-width: 60vmax;\n    width: 80% !important;\n}\n\n.SearchPanel {\n    width: 80%;\n    min-width: 60vmax;\n}\n\n@media (max-width: 768px) {\n    .TournamentPage{\n        >div:nth-child(2) {\n            /* border-bottom: 1px solid black; */\n            margin: 0px;\n            width: 100%;\n            /* background-color: white; */\n            /* padding: 0px 10px; */\n            border-radius: 0px;\n        }\n        >:nth-child(3) {\n            overflow-x: unset;\n            >table >tbody >tr {\n                >:nth-child(1) {\n                    display: none;\n                }\n            }\n            >table >thead >tr {\n                >:nth-child(1) {\n                    display: none;\n                }\n            }\n            >div {\n                width: 100vw;\n            }\n        }\n    }\n    .DataGrid{\n        width: 100% !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TournamentPage": `tournaments-list-page_TournamentPage__DeSCU`,
	"SearchQuery": `tournaments-list-page_SearchQuery__SDP5n`,
	"TableContainer": `tournaments-list-page_TableContainer__d-Dlm`,
	"ControlPanel": `tournaments-list-page_ControlPanel__xwrcp`,
	"DataGrid": `tournaments-list-page_DataGrid__QNBPl`,
	"SearchPanel": `tournaments-list-page_SearchPanel__jY02l`
};
export default ___CSS_LOADER_EXPORT___;
